module.exports = __webpack_public_path__ + "img/arrow-down-gray.0fafa921.svg";